import { cfg } from './src/runtime-config';

// Non-secret display/config values. Runtime values (window.env) win; the literals are
// local-dev fallbacks used when nothing is injected.
export const env = {
  OFFER_CDN_URL: cfg('OFFER_CDN_URL') || 'https://d3v7hbq4afry8x.cloudfront.net',
  CDN_ASSETS_BASE: cfg('CDN_ASSETS_BASE') || 'https://s3.amazonaws.com/whatif-assets-cdn/banners/stagingzuul2/',
  baseURL: cfg('BASE_URL') || 'http://localhost:9191/',
};
